import type { View } from 'cadenza/workbook/view/view';
import type { ViewSettingsPanelContentPromiseFunction } from 'cadenza/workbook/workbook-panel/settings/designer-settings-panel-content';

export const getExtensionViewsSettingsPanelContent = (view: View) =>
  import(
    'cadenza/workbook/workbook-panel/settings/other-views/extension-view-settings-panel-content'
  ) as unknown as ViewSettingsPanelContentPromiseFunction;
